// src/contexts/ProfileRoleContext.tsx
import React, { createContext, useState, useEffect, ReactNode } from "react";
import { ChangeProfile } from "app/views/profile";
import { Dialog } from "@mui/material";
import * as storage from "../data/storage";
import { useAuth } from "app/hooks/useAuth";

interface ProfileRoleContextType {
  role: string | null;
  isDialogOpen: boolean;
}

export const ProfileRoleContext = createContext({} as ProfileRoleContextType);

interface ProfileRoleProviderProps {
  children: ReactNode;
}

export const ProfileRoleProvider: React.FC<ProfileRoleProviderProps> = ({
  children,
}) => {
  const [role, setRoleState] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const savedRole = storage.get("role");
    if (savedRole) {
      setRoleState(savedRole);
    } else {
      if (isAuthenticated) {
        setIsDialogOpen(true);
      }
    }
  }, []); // eslint-disable-line

  return (
    <ProfileRoleContext.Provider value={{ role, isDialogOpen }}>
      {children}
      <Dialog fullWidth={true} maxWidth={"xl"} open={isDialogOpen}>
        <ChangeProfile isFromLogin={true} />
      </Dialog>
    </ProfileRoleContext.Provider>
  );
};
